(function () {
  'use strict';

  function scrollStorageKey() {
    return 'qdaLoadMoreScroll:' + location.pathname;
  }

  function saveScroll() {
    try {
      sessionStorage.setItem(scrollStorageKey(), String(window.scrollY));
    } catch (e) {
      /* ignore */
    }
  }

  function readScroll() {
    try {
      var v = sessionStorage.getItem(scrollStorageKey());
      return v === null ? null : parseInt(v, 10);
    } catch (e) {
      return null;
    }
  }

  function getPageParam() {
    var params = new URLSearchParams(location.search);
    var p = parseInt(params.get('page'), 10);
    return (!p || p < 1) ? 1 : p;
  }

  // Reconstruit l'URL de la page N en conservant les autres paramètres actuels
  // (filtres, tri, etc.), pour ne demander que le changement du numéro de page.
  function buildUrlForPage(pageNum) {
    var params = new URLSearchParams(location.search);
    if (pageNum > 1) {
      params.set('page', pageNum);
    } else {
      params.delete('page');
    }
    var qs = params.toString();
    return location.pathname + (qs ? '?' + qs : '');
  }

  function appendItemsFromHtml(html, sectionId, sectionEl, anchor) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');

    var newItems = doc.querySelectorAll('#shopify-section-' + sectionId + ' .grid.grid--uniform .grid__item');
    var currentGrid = sectionEl.querySelector('.grid.grid--uniform');

    if (!currentGrid || newItems.length === 0) {
      return { count: 0, nextHref: null };
    }

    var frag = document.createDocumentFragment();
    newItems.forEach(function (item) { frag.appendChild(item.cloneNode(true)); });

    if (anchor) {
      // Insertion avant un repère fixe : permet de reconstituer les pages
      // précédentes dans le bon ordre (1, 2, 3...) sans les empiler à l'envers.
      currentGrid.insertBefore(frag, anchor);
    } else {
      currentGrid.appendChild(frag);
    }

    var nextBtn = doc.querySelector('#shopify-section-' + sectionId + ' .qda-lm-btn');
    return { count: newItems.length, nextHref: nextBtn ? nextBtn.getAttribute('href') : null };
  }

  function updateCounterAndBar(wrap, addedCount) {
    var displayed = parseInt(wrap.dataset.displayed, 10) + addedCount;
    var total = parseInt(wrap.dataset.total, 10);
    wrap.dataset.displayed = displayed;

    var counter = wrap.querySelector('.qda-lm-counter');
    if (counter) {
      var tpl = counter.dataset.template || '';
      counter.textContent = tpl
        .replace(/\[shown\]/g, Math.min(displayed, total))
        .replace(/\[total\]/g, total);
    }

    var bar = wrap.querySelector('.qda-lm-bar');
    if (bar) {
      bar.style.width = Math.min(100, Math.round((displayed / total) * 100)) + '%';
    }
  }

  // Si on arrive directement sur une URL ?page=N (retour navigateur, lien
  // partagé, actualisation), on recharge et insère les pages 1..N-1 avant les
  // produits déjà rendus côté serveur, pour reconstituer la vue accumulée
  // exactement comme avant de quitter la page. Piloté uniquement par l'URL :
  // fonctionne quel que soit le chemin qui a mené à cette page.
  function prependPreviousPages(wrap, sectionId, sectionEl) {
    var currentPage = getPageParam();
    if (currentPage <= 1) return;

    var currentGrid = sectionEl.querySelector('.grid.grid--uniform');
    var anchor = currentGrid ? currentGrid.firstElementChild : null;

    var i = 1;
    (function loadNext() {
      if (i >= currentPage) {
        var savedScroll = readScroll();
        requestAnimationFrame(function () {
          if (savedScroll !== null) {
            window.scrollTo(0, savedScroll);
          }
          // AOS doit être réinitialisé après ces insertions hors du clic normal,
          // sinon les images restaurées restent bloquées à opacité 0 (invisibles).
          requestAnimationFrame(function () {
            if (window.AOS) { AOS.refreshHard(); }
          });
        });
        return;
      }

      fetch(buildUrlForPage(i))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (html) {
            var result = appendItemsFromHtml(html, sectionId, sectionEl, anchor);
            if (result.count > 0) {
              updateCounterAndBar(wrap, result.count);
            }
          }
          i++;
          loadNext();
        })
        .catch(function () { i++; loadNext(); });
    })();
  }

  function initLoadMore(sectionEl) {
    var wrap = sectionEl.querySelector('.qda-lm-wrap');
    var sectionId = wrap && wrap.dataset.sectionId;

    if (wrap && sectionId) {
      prependPreviousPages(wrap, sectionId, sectionEl);
    }

    sectionEl.addEventListener('click', function (e) {

      // Bouton Réessayer
      var retry = e.target.closest('.qda-lm-retry');
      if (retry) {
        var retryWrap = retry.closest('.qda-lm-wrap');
        var savedBtn = retryWrap && retryWrap.querySelector('.qda-lm-btn');
        if (savedBtn && retryWrap.dataset.retryUrl) {
          savedBtn.href = retryWrap.dataset.retryUrl;
          savedBtn.style.display = '';
          retry.closest('.qda-lm-error').style.display = 'none';
        }
        return;
      }

      // Bouton Afficher la suite
      var btn = e.target.closest('.qda-lm-btn');
      if (!btn || btn.getAttribute('aria-busy') === 'true') return;
      e.preventDefault();

      var lmWrap = btn.closest('.qda-lm-wrap');
      var nextUrl = btn.getAttribute('href');
      var lmSectionId = lmWrap.dataset.sectionId;
      var loadingText = btn.dataset.loadingText || 'Chargement...';
      var originalText = btn.textContent.trim();

      btn.setAttribute('aria-busy', 'true');
      btn.textContent = loadingText;
      lmWrap.dataset.retryUrl = nextUrl;

      fetch(nextUrl)
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var result = appendItemsFromHtml(html, lmSectionId, sectionEl, null);

          if (result.count === 0) {
            btn.style.display = 'none';
            return;
          }

          updateCounterAndBar(lmWrap, result.count);

          // Nouvelle entrée d'historique : l'URL reflète la page atteinte, pour
          // pouvoir la partager ou l'actualiser directement.
          history.pushState({}, '', nextUrl);

          if (result.nextHref) {
            btn.setAttribute('href', result.nextHref);
            btn.setAttribute('aria-busy', 'false');
            btn.textContent = originalText;
          } else {
            btn.style.display = 'none';
          }

          if (window.AOS) { AOS.refreshHard(); }

          var live = lmWrap.querySelector('.qda-lm-live');
          if (live) {
            live.textContent = result.count + ' nouveaux produits chargés.';
            setTimeout(function () { live.textContent = ''; }, 3000);
          }
        })
        .catch(function () {
          btn.setAttribute('aria-busy', 'false');
          btn.textContent = originalText;
          var errorEl = lmWrap.querySelector('.qda-lm-error');
          if (errorEl) errorEl.style.display = 'block';
        });
    });
  }

  // Mémoriser la position de scroll en continu (et juste avant de quitter),
  // pour la restaurer quand on revient reconstruire la page.
  window.addEventListener('pagehide', saveScroll);
  window.addEventListener('scroll', function () {
    clearTimeout(window.__qdaScrollTimer);
    window.__qdaScrollTimer = setTimeout(saveScroll, 200);
  }, { passive: true });

  // Init sur toutes les sections collection présentes
  document.querySelectorAll('[data-section-type="collection-grid"]').forEach(initLoadMore);

  // Réinit après un rechargement Ajax des filtres/tri d'Impulse
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target;
    if (el && el.querySelector('[data-section-type="collection-grid"]')) {
      initLoadMore(el.querySelector('[data-section-type="collection-grid"]'));
    }
  });

})();
